// import { Component } from "react";
import { useState } from "react";
import { RiMenu3Line } from "react-icons/ri";
import { Link } from "react-scroll";

const Links = () => {
  const links = [
    "about",
    "customers",
    "products",
    // "portfolio",
    // "testimony",
    // "news",
    "brands",
    "contact",
  ];

  const [linksVisibility, setLinksVisibility] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const toggleVisibility = (index) => {
    setLinksVisibility(prev=>!prev);
    setSelectedIndex(index);
  };

  return (
    <>
      <div className="links__button hide__button">
        <button className="btn menu" onClick={toggleVisibility}>
          <RiMenu3Line />
        </button>
      </div>
      <div className={`links ${!linksVisibility ? "hide__links" : ""}`}>
        {links.map((link, index) => {
          return (
            <Link
              // className={index==selectedIndex ? "active" : ""}
              activeClass="active"
              to={`${link}`}
              spy={true}
              smooth={true}
              offset={-200}
              duration={100}
              key={index}
              // onSetActive={() => toggleVisibility(index)}
              onClick={() => toggleVisibility(index)}
              
            >
              {link}
            </Link>
            // <a
            //   className={index==selectedIndex ? "active" : ""}
            //   href={`#${link}`}
            //   onClick={() => toggleVisibility(index)}
            //   key={index}
            // >
            //   {link}
            // </a>
          );
        })}
      </div>
    </>
  );
};

export default Links;
/*
class Links extends Component {
  constructor() {
    super();
    this.links = [
      "home",
      "about",
      "services",
      "portfolio",
      "testimony",
      "news",
      "contact"
    ];
    this.state = {
      linksVisibility: false
    };
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }
  toggleVisibility() {
    this.setState((lastState) => {
      return {
        linksVisibility: !this.state.linksVisibility
      };
    });
  }

  render() {
    return (
      <>
        <div className="links__button hide__button">
          <button className="btn menu" onClick={this.toggleVisibility}>
            <RiMenu3Line />
          </button>
        </div>
        <div
          className={`links ${
            !this.state.linksVisibility ? "hide__links" : ""
          }`}
        >
          {this.links.map((link, index) => {
            return (
              <a
                className={!index ? "active" : ""}
                href={`#${link}`}
                onClick={this.toggleVisibility}
              >
                {link}
              </a>
            );
          })}
        </div>
      </>
    );
  }
}
export default Links;
*/
